import React from "react";
import styled, { withTheme } from "styled-components";
import { Flex, Image, Box, Text, Link } from "../fundamentals";
import { ForgottenPasswordForm } from "../forms";
import { LinkLabels, Instructions } from "../../localisation";
import { Button } from "../elements";
import { useIsScreenMobile } from "../hooks/useMediaQuery";
import { useHistory } from "react-router-dom";

const StyledForgottenPasswordScreen = styled(Flex)`
  position: absolute;
  height: 100%;
  width: 100%;
  flex-direction: column;
  overflow: auto;
  background-image: url("/images/brand-identity/background.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const ForgottenPasswordScreen = ({ theme }) => {
  const isMobile = useIsScreenMobile();
  const history = useHistory();
  return (
    <StyledForgottenPasswordScreen bg="white">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Image
          src={
            process.env.PUBLIC_URL +
            `/images/brand-identity/${isMobile ? "logo-icon-black.svg" : "logo_horizontal-black.svg"}`
          }
          alt="logo"
          width={isMobile ? "25px" : "184px"}
          height={isMobile ? "35px" : ""}
          p={isMobile ? "35px 30px" : "35px 50px"}
        />
        <Box display="flex" alignItems="center" mr={isMobile ? "l" : "xxxl"}>
          {!isMobile && (
            <Text size="heading3" mr="s">
              {Instructions.noAccount}
            </Text>
          )}
          <Button
            buttonStyle="default"
            type="button"
            size={isMobile ? "small" : "medium"}
            fontSize={isMobile ? "13px" : "20px"}
            bg="white"
            p={isMobile ? "5px 12px" : "8.5px 20px"}
            fontWeight="700"
            onClick={(e) => {
              e.preventDefault();
              history.push("/register");
            }}
          >
            {LinkLabels.signup}
          </Button>
        </Box>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" pt="mega">
        <Box
          width={isMobile ? "325px" : "550px"}
          bg="white"
          p={isMobile ? "m" : "60px 60px 35px 60px"}
          mt={isMobile ? "l" : "xxl"}
          boxShadow="medium"
          borderRadius="20px"
        >
          <ForgottenPasswordForm />
        </Box>
      </Box>
    </StyledForgottenPasswordScreen>
  );
};

export default withTheme(ForgottenPasswordScreen);
